/**
 * @file common.js
 * @synopsis  公共接口
 */

import { instance } from '../index';
import { COMEIN_STATIC_CDN, COMEIN_ENV } from '../host';
import axios from 'axios';

const updateFileApi = '/api/admin/oss/upload';

const defaultConfig = {
  bodyType: 'form'
};

// 获取预发布环境的文件地址
export const getPreReleaseFileUrl = async () => {
  return await axios.get(`${COMEIN_STATIC_CDN}envs/${COMEIN_ENV}.json?${Math.random()}`);
};

// 上传文件
export const uploadFileAction = async (data, config = {}) => {
  return await instance.post(
    updateFileApi,
    {
      file: data.file,
      fileType: data.fileType
    },
    {
      ...config,
      bodyType: 'file',
      headers: {
        realm: data.goId
      }
    }
  );
};

// 根据key获取文件
export const getFileByKey = async (data, config = {}) => {
  return await instance.get('/api/admin/file/get', data, {
    responseType: 'blob',
    ...config
  });
};

// 根据key获取文件地址
export const getFileUrlByKey = async (data, config = defaultConfig) => {
  return await instance.post('/api/admin/oss/get-url', data, config);
};

// 客户端上传oss文件 专用的接口
export const getOssFileUrlByKey = async (data, config = defaultConfig) => {
  return await instance.post('/api/admin/oss/new/get-url', data, config);
};

// 获取部门列表(树形)接口
export const getDepartmentList = async (data, config) => {
  return await instance.post('/api/admin/department/tree', data, config);
};

// 查询国家区域编码列表
export const getCountryAreaCode = async (data = {}, config = {}) => {
  return await instance.post('/api/admin/common/country/list', { pageIndex: 0, pageSize: 1000, ...data }, config);
};

// 获取行为验证码凭证
export const getAuthInfoCode = async (data, config = {}) => {
  return await instance.get('/api/security/captcha/authInfo', data, config);
};

// 刷新token
export const refreshToken = async (data, config = {}) => {
  return await instance.post('/user/realms/{realm}/protocol/openid-connect/token', data, config);
};

// 筛选条件
export const getFilterConfigList = async (data, config = {}) => {
  return await instance.get('/api/admin/common/screen-component', data, config);
};

// 用户习惯相关
// 保存用户习惯
export const saveUserPreference = async (data, config = {}) => {
  return await instance.post('/api/admin/user/preference/save', data, config);
};
// 获取用户筛选条件组合列表
export const getUserPreferenceList = async (data, config = {}) => {
  return await instance.get('/api/admin/user/preference/selectList', data, config);
};
//  删除用户筛选条件组合
export const deleteUserPreference = async (data, config = {}) => {
  return await instance.post('/api/admin/user/preference/deleteById', data, config);
};
// 编辑用户筛选条件组合
export const updateUserPreference = async (data, config = {}) => {
  return await instance.post('/api/admin/user/preference/updateById', data, config);
};

// 上市公司关注
export const addStockAttention = async (data, config = {}) => {
  return await instance.post('/api/admin/attention/addStockAttention', data, config);
};

// 取消上市公司关注
export const cancelStockAttention = async (data, config = {}) => {
  return await instance.post('/api/admin/attention/cancelStockAttention', data, config);
};

// 检查是否关注个股
export const checkStockAttention = async (data, config = {}) => {
  return await instance.post('/api/admin/attention/isStockAttention', data, config);
};

// 检查是否关注行业
export const checkIndustryAttention = async (data, config = {}) => {
  return await instance.get('/api/admin/industry/attention', data, config);
};

// 用户关注行业
export const getUserIndustry = async (data, config = {}) => {
  return await instance.post('/api/admin/common/user/industry', data, config);
};

// 用户关注或取消关注行业
export const userOperationIndustry = async (data, config = {}) => {
  return await instance.post('/api/admin/industry/user/operation-industry', data, config);
};

export const getIndustryList = async (data, config = {}) => {
  return await instance.post('/api/admin/common/user/industry-pid', data, config);
};

export const addUserBrowseDetail = async (data, config = {}) => {
  return await instance.post('/api/admin/common/content/add-user-browse', data, config);
};

// 增加浏览记录
export const addUserBrowse = async (data, config = {}) => {
  return await instance.post('/api/admin/common/add-user-browse', data, config);
};
// 获取客户端上报启动信息
export const getStartupInfo = async (data, config = {}) => {
  return await instance.get('/api/admin/common/config/get-parameter', data, config);
};

// 浏览器上报成功获取启动信息
export const reportStartupInfo = async (data, config = {}) => {
  return await instance.post('/api/admin/common/config/set-parameter', data, config);
};
